import { usePreservedQueryParam } from './usePreservedQueryParam';

export function usePreservedQueryParamLink(originalLink: string) {
    const impersonateParams = usePreservedQueryParam();
    return originalLink + impersonateParams;
}
